export class InterfaceStatusModel {
  public instanceName: string;
  public status: string;
  public updatedDateTimeString: string;
  // public customerMasterHashId : string = '';
  // public instanceHashIdList: string[] = [''];

  constructor() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/interfacestatus/models/interfacestatus.model.ts